import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../components/common/Sidebar";
import { getCatalogues, getMediaUrl } from "../services/catalogueService";
import { isClientAuthenticated } from "../services/clientAuth";
import { Link } from "react-router-dom";
import "./DownloadCatalogue.css";

const catalogueDescription = [
  "VS jewelcast is undoubtedly the trend setter in market, having introduced many, new and unique ranges of CZ Jewellery.",
  "We are here to help our jewellery shop customers & jewellery craftsmen to explore numerous options from a huge variety of the latest & exclusive designer range of CZ Jewellery available in Our all Catalogues.",
  "We are our own competitor and we have consistently raised our level of performance to new heights of quality standards.",
  "Our rate of success in this arena is amply highlighted by our huge range of CZ jewellery designs, which keeps growing continually.",
];

const legacyCatalogues = [
  {
    _id: "legacy-gents-ring",
    title: "GENTS RING 1 WAX MODEL",
    imageUrl: "Catalogues/Photo/GENTS RING 1 COVER.jpg",
    pdfUrl: "Catalogues/Attach/GENTS RING 1 WAX MODEL.pdf",
    isActive: true,
    sequence: 1,
  },
  {
    _id: "legacy-vs4",
    title: "VS 4",
    imageUrl: "Catalogues/Photo/VS4_COVER.png",
    pdfUrl: "Catalogues/Attach/VS4.pdf",
    isActive: true,
    sequence: 2,
  },
  {
    _id: "legacy-vs5",
    title: "VS 5",
    imageUrl: "Catalogues/Photo/Screenshot_2013-11-01-03-12-43-1.png",
    pdfUrl: "Catalogues/Attach/Vs 5 2013.pdf",
    isActive: true,
    sequence: 3,
  },
  {
    _id: "legacy-cz3",
    title: "CZ 3",
    imageUrl: "Catalogues/Photo/vs jewel cast cover page 1.jpg",
    pdfUrl: "Catalogues/Attach/cz3.pdf",
    isActive: true,
    sequence: 4,
  },
  {
    _id: "legacy-vs2",
    title: "VS 2",
    imageUrl: "Catalogues/Photo/tital.jpg",
    pdfUrl: "Catalogues/Attach/VS2.pdf",
    isActive: true,
    sequence: 5,
  },
  {
    _id: "legacy-vs-forever",
    title: "VS FOREVER",
    imageUrl: "Catalogues/Photo/first_titel_forever.png",
    pdfUrl: "Catalogues/Attach/VS FOREVER.pdf",
    isActive: true,
    sequence: 6,
  },
  {
    _id: "legacy-vs-jewelery",
    title: "VS JEWELERY",
    imageUrl: "Catalogues/Photo/1.JPG",
    pdfUrl: "Catalogues/Attach/vs jewellery.pdf",
    isActive: true,
    sequence: 7,
  },
];

const AUTO_SLIDE_INTERVAL = 3000; // 3 seconds — minimal speed

export default function DownloadCatalogue() {
  const [catalogues, setCatalogues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const autoSlideRef = useRef(null);

  useEffect(() => {
    const fetchCatalogues = async () => {
      try {
        setLoading(true);
        setError("");
        const data = await getCatalogues();
        const downloadableCatalogues = data
          .filter(
            (item) =>
              (item?.imageUrl || item?.Photo || item?.pdfUrl || item?.Filepath)
          )
          .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
        setCatalogues(
          downloadableCatalogues.length ? downloadableCatalogues : legacyCatalogues
        );
      } catch (err) {
        console.error("Failed to load downloadable catalogues:", err);
        setCatalogues(legacyCatalogues);
      } finally {
        setLoading(false);
      }
    };
    fetchCatalogues();
  }, []);

  useEffect(() => {
    const updateVisibleCount = () => {
      setVisibleCount(window.innerWidth <= 680 ? 1 : 3);
    };
    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  // Duplicate small sets so carousel can slide
  const displayCatalogues =
    catalogues.length > 0 && catalogues.length <= 3
      ? [...catalogues, ...catalogues]
      : catalogues;

  const maxStartIndex = Math.max(displayCatalogues.length - visibleCount, 0);
  const canGoPrev = activeIndex > 0;
  const canGoNext = activeIndex < maxStartIndex;

  // Clamp activeIndex if catalogues change
  useEffect(() => {
    if (!displayCatalogues.length) { setActiveIndex(0); return; }
    if (activeIndex > maxStartIndex) setActiveIndex(maxStartIndex);
  }, [activeIndex, maxStartIndex]);

  // Auto-slide: 3 seconds interval, loops back to 0
  const startAutoSlide = () => {
    if (autoSlideRef.current) clearInterval(autoSlideRef.current);
    if (maxStartIndex === 0) return;
    autoSlideRef.current = window.setInterval(() => {
      setActiveIndex((prev) => (prev >= maxStartIndex ? 0 : prev + 1));
    }, AUTO_SLIDE_INTERVAL);
  };

  useEffect(() => {
    startAutoSlide();
    return () => { if (autoSlideRef.current) clearInterval(autoSlideRef.current); };
  }, [maxStartIndex]);

  // Pause on manual interaction, resume after
  const handleManualNav = (newIndex) => {
    setActiveIndex(newIndex);
    startAutoSlide(); // restart timer so it doesn't immediately jump
  };

  const handleCatalogueClick = (catalogue) => {
    console.log("Catalogue clicked:", catalogue.title);
    const authStatus = isClientAuthenticated();
    console.log("Is Authenticated:", authStatus);

    if (authStatus) {
      console.log("User is authenticated. Attempting download...");
      // Prefer Filepath (original server files in Catalogues/Attach/) over
      // pdfUrl which may contain UUID-named uploads that no longer exist
      const fileUrl = catalogue.Filepath || catalogue.pdfUrl;
      if (fileUrl) {
        const url = getMediaUrl(fileUrl);
        console.log("Opening PDF:", url);
        window.open(url, "_blank");
      } else {
        console.warn("No PDF URL found for this catalogue.");
      }
    } else {
      console.log("User not authenticated. Showing login prompt...");
      setShowLoginPrompt(true);
    }
  };



  return (
    <>
      <Sidebar showNewCreation={true} />
      <main className="content-area">
        <section className="download-showcase">

          {/* Header bar */}
          <div className="download-header">
            <h2>Download Catalogue</h2>
          </div>

          {/* Dark content box */}
          <div className="download-content-box">

            {loading && <p className="catalogue-status">Loading downloads...</p>}
            {error && <p className="catalogue-status error">{error}</p>}

            {!loading && !error && (
              catalogues.length > 0 ? (
                <>
                  {/* ---- Carousel ---- */}
                  <div className="download-carousel-shell">

                    {/* Prev arrow — absolute, centered on image band */}
                    <button
                      type="button"
                      className="download-arrow prev"
                      onClick={() => handleManualNav(Math.max(activeIndex - 1, 0))}
                      disabled={!canGoPrev}
                      aria-label="Previous catalogues"
                    >
                    </button>

                    {/* Sliding window */}
                    <div className="download-gallery-window">
                      <div
                        className="download-gallery"
                        style={{
                          transform: `translateX(-${(activeIndex * 100) / visibleCount}%)`,
                        }}
                      >
                        {displayCatalogues.map((catalogue, index) => {
                          const imageSrc = getMediaUrl(catalogue.imageUrl || catalogue.Photo);

                          return (
                            <article
                              className="download-showcase-card"
                              key={`${catalogue._id}-${index}`}
                            >
                              <button
                                type="button"
                                className="download-poster-link"
                                onClick={() => handleCatalogueClick(catalogue)}
                              >
                                {imageSrc ? (
                                  <img
                                    className="download-showcase-image"
                                    src={imageSrc}
                                    alt={catalogue.title}
                                  />
                                ) : (
                                  <div className="download-showcase-placeholder">
                                    CATALOGUE
                                  </div>
                                )}
                              </button>

                              <h3 className="download-showcase-title">
                                <button
                                  type="button"
                                  className="download-title-btn"
                                  onClick={() => handleCatalogueClick(catalogue)}
                                >
                                  {catalogue.title}
                                </button>
                              </h3>
                            </article>
                          );
                        })}
                      </div>
                    </div>

                    {/* Next arrow */}
                    <button
                      type="button"
                      className="download-arrow next"
                      onClick={() =>
                        handleManualNav(Math.min(activeIndex + 1, maxStartIndex))
                      }
                      disabled={!canGoNext}
                      aria-label="Next catalogues"
                    >
                    </button>
                  </div>

                  {/* Description paragraphs */}
                  <div className="download-copy-block">
                    {catalogueDescription.map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))}
                  </div>
                </>
              ) : (
                <p className="catalogue-status">No downloadable catalogue files available yet.</p>
              )
            )}

          </div>
        </section>

        {showLoginPrompt && (
          <div className="auth-popup-backdrop">
            <div className="auth-popup-card" onClick={(e) => e.stopPropagation()}>
              <button
                type="button"
                className="auth-popup-close"
                onClick={() => setShowLoginPrompt(false)}
                aria-label="Close"
              >
              </button>
              <div className="auth-popup-content">
                <p className="auth-popup-main-text">
                  Please <Link to="/login" onClick={() => setShowLoginPrompt(false)}>LOGIN</Link> Here
                </p>
                <p className="auth-popup-or">Or</p>
                <p className="auth-popup-main-text">
                  <Link to="/register" onClick={() => setShowLoginPrompt(false)}>SIGN UP</Link> Now !!
                </p>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
}
